export default __webpack_public_path__ + "static/media/loose.32961762.gif";